module.exports = __webpack_public_path__ + "img/bmgj-tab-pc.5a1a39de.svg";